import { takeLatest, select, put, call, all, race, takeMaybe, delay } from 'redux-saga/effects';
import getBrowserHistory from 'yoda-core-components/lib/navigation/history/getBrowserHistory';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import find from 'lodash/find';
import map from 'lodash/map';
import filter from 'lodash/filter';
import User from 'yoda-site-components/lib/helpers/User/User';
import FactorySaga from 'yoda-site-components/lib/sagas/FactorySaga';
import sessionActions from 'yoda-site-components/lib/actions/SessionAction';
import TokenProvider from 'yoda-core-components/lib/helpers/TokenProvider/TokenProvider';
import { getEnterpriseSiteKey } from 'yoda-site-components/lib/utils';
import {
    updateGuestPaymentCVV,
    submitPayment,
    submitBillingAddress,
    putEmailAddress,
    deletePaymentMethod,
} from 'yoda-interfaces/lib/Order/OrderApi';
import {
    CONTINUE_PROCESSING_APP_GIFT_CARDS,
    GIFT_CARDS_FROM_APP,
} from 'yoda-site-components/lib/actionTypes/NativeAppActionTypes';
import {
    getNativeGiftCards,
    postAccountLockInfo,
} from 'yoda-site-components/lib/actions/NativeAppAction';
import { removeGiftCard, applyGiftCard } from 'yoda-interfaces/lib/Order/BillingApi';
import {
    optin as optIn,
    addAddress,
    updatePayment,
    addPayment,
    fetchPaymentMethods,
    fetchB2bPayment,
    deletePayment,
} from 'yoda-interfaces/lib/Account/AccountApi';
import Cookies from 'yoda-core-components/lib/helpers/Cookies/Cookies';
import showGlobalLoader from 'yoda-checkout-components/lib/actions/ShowGlobalLoaderAction';
import siteAnalyticsAction from 'yoda-site-components/lib/actions/AnalyticsAction';
import ClientSideLoggerAction from 'yoda-site-components/lib/actions/ClientLoggerAction';
import * as CheckoutAnalyticsAction from 'yoda-checkout-components/lib/actions/CheckoutAnalyticsAction';
import {
    URL_REVIEW_PAGE,
    STREET_ERROR_MESSAGE,
    ADJUSTMENT_TYPE_RESTRICTED,
    ADJUSTMENT_TYPE_ASSOC_DISCOUNT,
    ANALYTICS_ACTIONS_APP_WALLET_GIFT_CARD_APPLY,
    SESSION_ERROR_PAYMENT_TITLE,
    ANALYTICS_GUEST_EMAIL_OPTIN,
    ACCOUNT_LOCKED,
    ADI_INITIATE_CHECKOUT_EXCEPTION_HANDLER,
} from 'yoda-checkout-components/lib/common/Constants';
import { getClientId } from 'yoda-checkout-components/lib/helpers/Utils/Utils';
import { SET_SERVICE_ERROR } from 'yoda-site-components/lib/common/Constants';
import { CLEAR_ORDER_ERROR } from 'yoda-checkout-components/lib/actionTypes/ServiceErrorHandlerActionTypes';
import {
    getAccertifyDeviceInfo,
    logExtendedAnalytics,
} from 'yoda-site-components/lib/sagas/SiteProbingSaga';
import { getAccertifyStatus } from 'yoda-site-components/lib/helpers/Utils/utils';
import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';
import {
    validateCreditCardFormField,
    isMaxLengthPaypalServiceError,
    validateGiftCardForm,
    getAppliedAppGCList,
    validateCreditCardForm,
    getStoreNumber,
    getPreferredPaymentCard,
} from '../helpers/Utils/Utils';
// eslint-disable-next-line import/no-cycle
import CartDetailsSaga from './CartDetailsSaga';
import * as CartActionTypes from '../actionTypes/CartActionTypes';
import * as newPaymentActionTypes from '../actionTypes/NewPaymentActionTypes';
import * as newPaymentAction from '../actions/NewPaymentAction';
import * as paymentActionTypes from '../actionTypes/PaymentActionTypes';
import PaymentService from '../services/PaymentService';
import ShippingService from '../services/ShippingService';
import * as newShippingAction from '../actions/NewShippingAction';
// eslint-disable-next-line import/no-cycle
import { getCustomerAddress, handleADIResponseforAnalytics } from './NewShippingSaga';
import { orderShippingToHomeInfoSelector } from '../selectors/NewShippingSelector';
import {
    getBillingAddressInOrderDetails,
    selectBnplBlocked,
    selectBnplOnOrder,
} from '../selectors/NewPaymentMethodSelector';

const paymentInfoSelector = (state) => state.newPayment;
const orderContactInfoSelector = (state) => state.orderContactInfo;
const context = (state) => state.context;
const orderDetails = (state) => state.orderDetails;
const orderBillingInfoSelector = (state) =>
    get(state, 'orderDetails.data.billing.creditCards.cards[0]');
const userPaymentListSelector = (state) => state.newPayment.userPaymentList;
const userInputBillingSelector = (state) =>
    get(state, 'newShipping.shipToHomeInfo.userInputAddress');
const userInputAddressSelector = (state) =>
    get(state, 'newShipping.shipToHomeInfo.userInputAddress.address');
const isZipInvalidFromAPISelector = (state) =>
    get(state, 'newShipping.shipToHomeInfo.userInputAddress.isZipInvalidFromAPI');
const phoneNumber = (state) =>
    get(state, 'newPayment.creditCardUserInputInfo.billingAddress.phone');
const standardizationNotRequiredSelector = (state) =>
    state.newPayment.xStandardizationNotRequired || false;
export const errorHandler = {
    context: 'PAYMENT',
    errorComponent: 'PAYMENT_SECTION',
};

/**
 * To Update existing "orderDetails" value in selector
 */
function* updateOldCartDetailsSaga(
    pageName = 'payment',
    isPreLoadCall = false,
    isAddBnplPaymentCouponHeader = false
) {
    const payload = {
        includeServiceLevels: true,
        pageName,
        isPreLoadCall,
        isAddBnplPaymentCouponHeader,
    };
    const action = {
        type: CartActionTypes.CART_DETAILS_GET_REQUEST,
        payload,
    };
    yield call(CartDetailsSaga, action);
}

/**
 * Handle add credit card to order failed
 */

export function* addCreditCardToOrderErrorHandler(result, actionMethod) {
    const errorCode = get(result, 'response.data[0].errorCode', '');
    const errorMessage = get(result, 'response.data[0].errorMessage', null);
    const contextSelector = yield select(context);
    const isNative = get(contextSelector, 'isNative', false);
    const actionName = 'syf_bnpl_api_failure';
    const traceID = result?.response?.headers.get('x-trace-id') || '';
    const quantumSessionID = Cookies.load('QuantumMetricSessionID') || '';
    if (
        errorCode === 'SRV_CUSTOMER_ADDRESS_ONE_INVALID' ||
        errorCode === 'STREET_FAILURE' ||
        errorCode === 'HOUSE_RANGE_FAILURE' ||
        errorCode === 'STANDARDIZATION_SERVICE_FAILURE' ||
        errorCode === 'SRV_ORDER_PAYPAL_INVALID_BILLING_ADDRESS' ||
        errorCode === 'STREET_COMPONENT_FAILURE' ||
        errorCode.indexOf('SRV_CUSTOMER_STD_CDI') !== -1
    ) {
        // TODO should update in shipping action
        yield put(newPaymentAction.setAddressStandNotRequired(true));
    }

    /** Log BNPL Aurora error logs to Kibana */
    const errorDescription = 'SYF BNPL Aurora error';
    yield put(
        ClientSideLoggerAction.logError(
            errorDescription,
            `actionName: | ${actionName} |errorCode: ${errorCode} | |errorMessage: ${errorMessage} | user-agent:${window?.navigator?.userAgent} | quantumSessionID:${quantumSessionID} | traceID:${traceID} | isNative:${isNative}`
        )
    );
    /** trigger ADI Denied Analytics event for all/most of the scenerios here */
    const isRegisteredUser = TokenProvider.get('DP_USER_STATE') === '1';
    yield call(logExtendedAnalytics, {
        actionMethod: actionMethod || (isRegisteredUser ? 'ADD_CC_REGISTERED' : 'ADD_CC_GUEST'),
        result,
    });
    if (errorCode === 'SRV_SESSION_TIMEOUT') {
        const errorContent = {
            errorMessage,
            redirectUrl: User.isUserLoggedIn() ? '/checkout/account-locked' : null,
            errorFrom: ACCOUNT_LOCKED,
        };
        yield put(sessionActions.setSessionTimeOutMsg(errorContent));
        if (isNative) {
            const data = {
                message: errorMessage,
                title: SESSION_ERROR_PAYMENT_TITLE,
                url: '/checkout/account-locked',
                cta: 'OK, got it',
            };
            yield put(postAccountLockInfo(data));
        }
        TokenProvider.logout();
        !isNative && (yield put(sessionActions.setSessionTimeOut(true)));
    }
}

/**
 * handle promo finance
 */

export function* handlePromoFinance() {
    yield put({ type: CLEAR_ORDER_ERROR, payload: 'reviewPayment' });
    yield put(showGlobalLoader(true));
    yield call(updateOldCartDetailsSaga, 'review', true);
    const orderBillingInfo = yield select(orderBillingInfoSelector);
    const appContext = yield select(context);
    const checkPromoFinanceEligible = get(
        appContext,
        'featureFlags.checkPromoFinanceEligible',
        true
    );
    const promoFinanceEligible = get(orderBillingInfo, 'financing.href');
    // TODO: To clean this code once PromoFinace logic move to new PaymentAction
    if (checkPromoFinanceEligible && promoFinanceEligible) {
        const paymentInfo = [];
        const cardItem = {
            id: orderBillingInfo.id,
            paymentMethod: 'creditCard',
            type: orderBillingInfo.type,
            lastFour: `**${orderBillingInfo.lastFour}`,
            amount: orderBillingInfo.amount,
            status: orderBillingInfo.status,
        };
        paymentInfo.push(cardItem);
        const payload = {
            cardId: cardItem.id,
        };
        yield put({
            type: paymentActionTypes.GET_PROMO_FINANCING_OFFERS,
            payload,
        });
    } else {
        const promoFinanceData = {};
        yield put({
            type: paymentActionTypes.SET_REWARD_PROMO_FINANCE_DECISION,
            promoFinanceData,
        });
        getBrowserHistory().push(URL_REVIEW_PAGE);
    }
}

/**
 * Validate billing info form fields and fire errors to UI and analytics.
 * @return errorInfo
 */
function* checkFormErrors() {
    const paymentInfo = yield select(paymentInfoSelector);
    const contextInfo = yield select(context);
    let errorInfo = {};
    const isPartialGiftcardPayment = get(paymentInfo, 'isPartialGiftcardPayment', false);
    if (isPartialGiftcardPayment) {
        errorInfo = validateCreditCardForm(paymentInfo, contextInfo);
        yield put(newPaymentAction.showHideGiftCardForm(false));
    }
    if (paymentInfo.showEditBillingAddressForm) {
        const billingAddress = yield select(userInputAddressSelector);
        const isZipInvalidFromAPI = yield select(isZipInvalidFromAPISelector);
        if (!User.isUserLoggedIn()) {
            billingAddress.phone = yield select(phoneNumber);
        }
        const billingInfo = yield select(userInputBillingSelector);
        const billingAddressErrorInfo = ShippingService.validateShippingAddressForm(
            billingAddress,
            [],
            isZipInvalidFromAPI
        );
        if (isEmpty(billingAddressErrorInfo) && !billingInfo.isStreetAddressCheckExecuted) {
            const isNotValidStreetAddress = !ShippingService.isValidStreetAddress(
                billingAddress.lineOne,
                billingAddress.country
            );
            if (isNotValidStreetAddress) {
                billingAddressErrorInfo.lineOne = STREET_ERROR_MESSAGE;
            }
            yield put(newShippingAction.setStreetAddressCheckExecuted(true));
        }
        errorInfo = Object.assign(errorInfo, billingAddressErrorInfo);
    }
    if (!isEmpty(errorInfo)) {
        /*
         * Set form error into the payment form
         */
        yield all([
            put(
                siteAnalyticsAction.triggerFormError(
                    PaymentService.getDAPaymentFormError(errorInfo)
                )
            ),
            put(newShippingAction.updateShippingAddressFormError(errorInfo)),
        ]);
        if (isPartialGiftcardPayment) {
            yield put(newPaymentAction.updateCreditCardFormError(errorInfo));
        }
        /**
         * Setting Auto focus to first error fields
         */
        const errorKeys = Object.keys(errorInfo);
        const errorField = document.getElementById(errorKeys[0]);
        errorField && errorField.focus();
    }
    return errorInfo;
}

/**
 * Update payment into the order
 * @param cardId, guestBillingPayload
 * @return response of OrderApi.updateGuestPaymentCVV API
 */

function* updateCreditCardInfoToOrder(cardId, guestBillingPayload) {
    const updateBillingPayload = {
        payload: {
            cardId,
            inputVal: { op: 'replace', path: '/cvv', value: guestBillingPayload.cvv },
            addressVal: { op: 'replace', path: '/address', value: guestBillingPayload.address },
            errorHandler,
        },
    };
    if (guestBillingPayload.captcha) {
        updateBillingPayload.payload.captcha = guestBillingPayload.captcha;
    }
    if (guestBillingPayload.isXStandardizationRequired) {
        updateBillingPayload.payload.isXStandardizationRequired =
            guestBillingPayload.isXStandardizationRequired;
    }
    if (guestBillingPayload.expiryMonth) {
        updateBillingPayload.payload.expiryMonthVal = {
            op: 'replace',
            path: '/expiryMonth',
            value: guestBillingPayload.expiryMonth,
        };
    }
    if (guestBillingPayload.expiryYear) {
        updateBillingPayload.payload.expiryYearVal = {
            op: 'replace',
            path: '/expiryYear',
            value: guestBillingPayload.expiryYear,
        };
    }
    if (guestBillingPayload.deviceInfo) {
        updateBillingPayload.payload.deviceInfo = guestBillingPayload.deviceInfo;
    }
    return yield call(FactorySaga, updateGuestPaymentCVV, updateBillingPayload);
}

function* handleCaptchaAnalytics(
    result,
    captchaHeader,
    actionName
    // analyticsEventName,
    // enableEnterpriseV3Captcha
) {
    const quantumSessionID = Cookies.load('QuantumMetricSessionID') || '';
    const errorInfo = Array.isArray(result?.response?.data)
        ? result?.response?.data[0]
        : result?.response?.data;
    const traceID = result?.response?.headers.get('x-trace-id') || errorInfo?.traceId;
    // if (enableEnterpriseV3Captcha && captchaHeader) {
    //     if (result.isSuccess) {
    //         yield put(
    //             CheckoutAnalyticsAction.triggerCaptchaAnalytics({
    //                 eventName: analyticsEventName,
    //                 data: { code: captchaHeader },
    //             })
    //         );
    //     } else if (result.response?.status === 400) {
    //         const errorData = {
    //             error: { errorDescription: errorInfo?.errorMessage || '' },
    //             fraudForceErrData: { code: captchaHeader, src: '3' },
    //         };
    //         yield call(triggerAndLogError, errorData, 'Error in processing captcha token');
    //     }
    // }

    /**
     *  if status is 400, && error code is KEY_OCS_CREDIT_CARD_AUTH_FAILED, && !captchaHeader && not from ADIREJECT
     *  Assuming it as $0 auth failure - analytics
     */
    const adiStatus = result?.response?.headers?.get('x-adi-sts');
    const isAdiMonitoringMode = result?.response?.headers?.get('x-adi-monitor');
    const isEnforcementModeReject = !isAdiMonitoringMode && adiStatus === 'R';
    function* triggerAndLogError(errorData, errorDescription) {
        yield put(siteAnalyticsAction.triggerFormError(errorData));
        yield put(
            ClientSideLoggerAction.logError(
                errorDescription,
                `actionName: | ${actionName} |responseCode: ${result?.response?.status} | user-agent:${window?.navigator?.userAgent} | quantumSessionID:${quantumSessionID} | traceID:${traceID}`
            )
        );
    }
    if (!captchaHeader && !isEnforcementModeReject) {
        const errorData = {
            error: { errorDescription: errorInfo?.errorMessage || '' },
            fraudForceErrData: { src: '4' },
        };
        const is$0auth =
            result?.response?.status === 400 &&
            (errorInfo?.errorCode === 'KEY_OCS_CREDIT_CARD_AUTH_FAILED' ||
                errorInfo?.errorCode === 'SRV_OCS_CALL_CREDIT_AUTH_FAILED');
        const isAccountLock =
            result?.response?.status === 403 && errorInfo?.errorCode === 'SRV_SESSION_TIMEOUT';
        if (is$0auth) {
            if (errorInfo?.errorCode === 'SRV_OCS_CALL_CREDIT_AUTH_FAILED') {
                delete errorData.fraudForceErrData;
            }
            yield call(triggerAndLogError, errorData, 'Error in $0 auth');
        } else if (isAccountLock) {
            delete errorData.fraudForceErrData;
            const isUserLoggedIn = User.isUserLoggedIn();
            const errorDescription = isUserLoggedIn
                ? 'payment Account locked for regisetered user'
                : 'payment Account locked for guest user';
            yield call(triggerAndLogError, errorData, errorDescription);
        }
    }
}

function* handleCreditCardADIChallenge(result, otherParams) {
    const { actionMethod, adiSts, isTriggerFromLS = false, errorMessage, traceId } = otherParams;
    const errorInfo = Array.isArray(result?.response?.data)
        ? result?.response?.data[0]
        : result?.response?.data;
    const adiStatus = result?.response?.headers.get('x-adi-sts');
    const appContext = yield select(context);
    const enableAccertifyADI = get(appContext, 'featureFlags.enableAccertifyADI');

    if (
        enableAccertifyADI &&
        ((errorInfo?.errorCode === 'SRV_CREDIT_CARD_CVV_REENTRY_REQUIRED' &&
            getAccertifyStatus(adiStatus).isChallenge) ||
            result?.fromIntiateCheckout)
    ) {
        const userPaymentList = yield select(userPaymentListSelector);
        const selectedPayment = find(userPaymentList, { selected: true }) || {};
        const contextInfo = yield select(context);
        const options = {
            context: contextInfo,
        };
        yield put(newPaymentAction.initRegisterUpdateCreditCardForm(selectedPayment, {}, options));
        !result?.fromIntiateCheckout
            ? yield call(logExtendedAnalytics, {
                  result,
                  actionMethod,
                  adiStatus: adiSts,
                  isTriggerFromLS,
                  traceId,
                  errorMessage,
              })
            : '';
    }
}

/**
 * Add payment into the order
 * @param paymentInfo
 */
function* addCreditCardInfoToOrder(paymentInfoParam, handleResultOnCaller) {
    const paymentInfo = { ...paymentInfoParam };
    const contextSelector = yield select(context);
    const orderDetailsInfo = yield select(orderDetails);
    const xStandardizationNotRequired = yield select(standardizationNotRequiredSelector);
    const defaultStoreID = get(contextSelector, 'preferences.defaultStoreID', '4302');
    let actionName = 'Checkout_add_credit_card';
    // let analyticsEventName = 'cpac';
    // const { enableEnterpriseV3Captcha } = (contextSelector || {}).featureFlags || {};
    const cardInfo = get(paymentInfo, 'creditCardUserInputInfo.cardInfo', {});
    let billingAddress = null;
    if (paymentInfo.showEditBillingAddressForm) {
        billingAddress = yield select(userInputAddressSelector);
    }
    paymentInfo.xStandardizationNotRequired = xStandardizationNotRequired;
    const guestBillingPayload = PaymentService.guestBillingPayload(
        cardInfo.id,
        paymentInfo,
        errorHandler,
        billingAddress
    );
    let result = null;
    if (paymentInfo.captchaToken) {
        guestBillingPayload.payload.captcha = { token: paymentInfo.captchaToken };
    }
    const enableSYFStoreNumber = get(contextSelector, 'featureFlags.enableSYFStoreNumber', true);
    if (enableSYFStoreNumber) {
        const storeId = getStoreNumber(orderDetailsInfo, defaultStoreID);
        if (storeId) {
            guestBillingPayload.payload.storeId = storeId;
        }
    }
    if (!cardInfo.id || cardInfo.number !== paymentInfo.selectedCardInfo.number) {
        const notFormattedCardNumber = cardInfo.number.replace(/[^(0-9)|*]/g, '');
        guestBillingPayload.payload.number = notFormattedCardNumber;
        /*
         * Add payment info into the order
         */
        const { deviceType } = contextSelector;
        const deviceClientId = getClientId(deviceType);
        guestBillingPayload.payload.clientId = deviceClientId;
        const deviceInfo = yield call(getAccertifyDeviceInfo, { actionName });
        if (deviceInfo) {
            guestBillingPayload.payload.deviceInfo = deviceInfo;
        }
        result = yield call(FactorySaga, submitPayment, guestBillingPayload);
    } else {
        /*
         * Update payment info into the order
         */
        actionName = 'Checkout_update_credit_card';
        // analyticsEventName = 'cpuc';
        const deviceInfo = yield call(getAccertifyDeviceInfo, { actionName });
        if (deviceInfo) {
            guestBillingPayload.payload.deviceInfo = deviceInfo;
        }
        result = yield call(updateCreditCardInfoToOrder, cardInfo.id, guestBillingPayload.payload);
    }
    if (result.isSuccess) {
        yield put(newPaymentAction.setAddressStandNotRequired(false));
    }
    if (!handleResultOnCaller) {
        const isRegisteredUser = TokenProvider.get('DP_USER_STATE') === '1';
        let actionMethod;
        if (actionName.includes('add')) {
            actionMethod = isRegisteredUser ? 'ADD_CC_REGISTERED' : 'ADD_CC_GUEST';
        } else {
            actionMethod = isRegisteredUser ? 'UPDATE_CC_REGISTERED' : 'UPDATE_CC_GUEST';
        }
        if (result.isSuccess) {
            const isNativeAndroid = get(contextSelector, 'isNativeAndroid', false);
            /** trigger ADI Success Analytics event */
            yield call(logExtendedAnalytics, {
                result,
                isTriggerFromLS: !isNativeAndroid,
                actionMethod,
            });
            yield call(handlePromoFinance);
        } else {
            yield call(addCreditCardToOrderErrorHandler, result, actionMethod);
        }
    }
    const headers = get(result, 'response.headers');
    const captchaHeader = headers && headers.get('x-svrc');
    yield call(
        handleCaptchaAnalytics,
        result,
        captchaHeader,
        actionName
        // analyticsEventName
        // enableEnterpriseV3Captcha
    );
    return result;
}

// function* addEmailToOrder(email) {
//     const emailPayload = {
//         payload: {
//             params: {
//                 type: 'EMAIL',
//                 purpose: 'TRANSACTIONAL',
//                 value: email,
//             },
//             errorHandler,
//         },
//     };
//     const result = yield call(FactorySaga, putEmailAddress, emailPayload);
//     return result.isSuccess;
// }

/**
 * Adds virtual credit card and billing address to the order
 * @param {Object} action contains token from SYF
 */
function* addBnplToOrder(action) {
    try {
        // const {
        //     vcn,
        //     order_data: { billing_address },
        //     order_id,
        // } = authResponse;

        // disables the widget while klarna info is being posted
        // yield put(klarnaWidgetReady(false));

        // Adds email to order for a guest user
        // if (!User.isUserLoggedIn()) {
        //     const emailAddedToOrder = yield addEmailToOrder('lthores2@jcp.com');
        //     /**
        //      * If email is not added to order
        //      * Reset the widget and show it again
        //      * Service error would be displayed on top
        //      */
        //     if (!emailAddedToOrder) {
        //         // yield put(klarnaReload());
        //         return;
        //     }
        // }

        // const number = yield getMappedCard(vcn.pan);
        // const orderTotals = yield select(orderTotalsSelector);
        // const isMilitaryCity =
        //     ShippingService.isMilitaryAddress(billing_address.city) &&
        //     billing_address.country === 'US';
        const billingPayload = {
            payload: {
                transactionToken: action.value,
                // address: {
                //     city: billing_address.city,
                //     country: isMilitaryCity ? 'AP' : billing_address.country,
                //     firstName: billing_address.given_name,
                //     lastName: billing_address.family_name,
                //     lineOne: billing_address.street_address,
                //     lineTwo: billing_address.street_address2,
                //     state: billing_address.region,
                //     zip: billing_address.postal_code,
                //     // remove any special character and send last 10 digits
                //     phone: billing_address.phone.replace(/\D+/g, '').slice(-10),
                //     ...(isMilitaryCity && {
                //         militaryAddressType: billing_address.city,
                //     }),
                // },
                // type: (Utils.getCreditCardType(number) || {}).name || 'visa',
                // expiryMonth: `${vcn.expiration_month}`,
                // expiryYear: `20${vcn.expiration_year}`,
                // cvv: vcn.cvv,
                // number,
                isXStandardizationRequired: false,
                errorHandler,
            },
        };
        const { deviceType } = yield select(context);
        const deviceClientId = getClientId(deviceType);
        billingPayload.payload.clientId = deviceClientId;
        yield put(showGlobalLoader(true));
        const result = yield call(FactorySaga, submitPayment, billingPayload);
        if (result.isSuccess) {
            yield call(handlePromoFinance);
        } else {
            // yield put(klarnaReload());
            yield call(addCreditCardToOrderErrorHandler, result);
            yield put(showGlobalLoader(false));
        }
    } catch (err) {
        // yield logError('ADD KLARNA TO ORDER', err.message);
        // yield disableKlarnaWithError();
        yield put(showGlobalLoader(false));
    }
}

/**
 * call Optin once Email Subscription Selected
 * @param paymentInfo
 */
function* addOptinInfoToOrder(paymentInfo) {
    const emailSubscription = get(paymentInfo, 'creditCardUserInputInfo.emailSubscription', false);
    if (emailSubscription) {
        const billingFormEmailId = get(paymentInfo, 'creditCardUserInputInfo.emailId', '');
        const optInPayload = {
            payload: {
                type: 'EMAIL',
                value: billingFormEmailId,
            },
        };
        yield call(FactorySaga, optIn, optInPayload);
    }
}

/**
 * Add payment into the order
 * @param paymentInfo
 */
function* addBillingAddressInfoToOrder(paymentInfo) {
    let billingAddress = get(paymentInfo, 'creditCardUserInputInfo.billingAddress', {});
    if (isEmpty(billingAddress)) {
        billingAddress = yield select(getBillingAddressInOrderDetails);
    }
    if (paymentInfo.showEditBillingAddressForm) {
        billingAddress = yield select(userInputAddressSelector);
    }
    // For guest user phone number will not be in billing address
    if (!User.isUserLoggedIn()) {
        billingAddress.phone = yield select(phoneNumber);
    }
    const notFormattedPhoneNumber =
        billingAddress.phone && billingAddress.phone.replace(/[^(0-9)|*]/g, '');
    const billingAddressLineTwo = billingAddress.lineTwo || billingAddress.addressLineTwo;
    const billingPayload = {
        payload: {
            firstName: billingAddress.firstName,
            lastName: billingAddress.lastName,
            lineOne: billingAddress.lineOne || billingAddress.addressLineOne,
            city: billingAddress.city,
            state: billingAddress.state,
            country: billingAddress.country,
            zip: billingAddress.zip,
            phone: notFormattedPhoneNumber,
            errorHandler,
        },
    };
    if (billingAddress.country === 'AP') {
        const city = billingAddress.militaryAddressType || billingAddress.city;
        billingPayload.payload.city = city;
        billingPayload.payload.militaryAddressType = city;
    }
    if (ShippingService.isMilitaryAddress(billingAddress.country)) {
        billingPayload.payload.city = billingAddress.country;
        billingPayload.payload.militaryAddressType = billingAddress.country;
        billingPayload.payload.country = 'AP';
    }
    billingAddressLineTwo && (billingPayload.payload.lineTwo = billingAddressLineTwo);
    billingAddress.company && (billingPayload.payload.company = billingAddress.company);
    billingAddress.secondaryPhone &&
        (billingPayload.payload.secondaryPhone = billingAddress.secondaryPhone);

    /*
     * Set address standardization for billing address
     */
    if (!paymentInfo.showEditBillingAddressForm || paymentInfo.xStandardizationNotRequired) {
        billingPayload.payload.isXStandardizationRequired = 'false';
    }
    const result = yield call(FactorySaga, submitBillingAddress, billingPayload);
    if (result.isSuccess) {
        yield call(handlePromoFinance);
    } else {
        yield call(addCreditCardToOrderErrorHandler, result);
    }
}

/**
 * Add billing address into profile
 * @param billingAddress
 * @return response of AccountApi.addAddress API
 */
function* addBillingAddressToProfile(billingAddress) {
    const billingAddressLineTwo = billingAddress.lineTwo;
    const billingAddressLineThree = billingAddress.lineThree;
    const billingAddressPayload = {
        firstName: billingAddress.firstName,
        lastName: billingAddress.lastName,
        addressLineOne: billingAddress.lineOne,
        city: billingAddress.city,
        state: billingAddress.state,
        zip: billingAddress.zip,
        country: billingAddress.country,
        phone: billingAddress.phone,
    };
    if (billingAddressPayload.country.includes('Country')) {
        billingAddressPayload.country = 'US';
    }
    billingAddressLineTwo && (billingAddressPayload.addressLineTwo = billingAddressLineTwo);
    billingAddressLineThree && (billingAddressPayload.addressLineThree = billingAddressLineThree);
    billingAddress.company && (billingAddressPayload.company = billingAddress.company);
    billingAddress.secondaryPhone &&
        (billingAddressPayload.secondaryPhone = billingAddress.secondaryPhone);
    if (ShippingService.isMilitaryAddress(billingAddress.city)) {
        billingAddressPayload.militaryAddressType = billingAddress.city;
    }

    const profileBillingAddressPayload = {
        payload: billingAddressPayload,
    };
    profileBillingAddressPayload.payload.errorHandler = errorHandler;

    // handle ADI for enableADIAccountUpdate
    const enableADIAccountUpdate = get(context, 'featureFlags.enableADIAccountUpdate', true);
    if (enableADIAccountUpdate) {
        const deviceInfo = yield call(getAccertifyDeviceInfo, {
            actionName: 'add_addressToProfileBilling',
            enableFeatureSpecificFlag: enableADIAccountUpdate,
        });
        if (deviceInfo) {
            profileBillingAddressPayload.payload.deviceInfo = deviceInfo;
        }
    }
    const result = yield call(FactorySaga, addAddress, profileBillingAddressPayload);
    yield call(handleADIResponseforAnalytics, result, 'ADD_ADDRESS_PROFILE_BILLING');
    return result;
}

/**
 * Add or update payment into the user profile based on card id
 * @param paymentInfo
 * @param isITRM
 * @return response of AccountApi.updatePayment or AccountApi.addPayment API
 */
function* addCreditCardInfoToProfile(paymentInfo, isITRM) {
    // TODO Add one more check to identify the billing address got changed or not
    let addressId = null;
    // let analyticsCode = 'cpac';
    const relationshipAddressId =
        get(
            paymentInfo,
            'creditCardUserInputInfo.billingAddress.relationships.accountAddress.id'
        ) || get(paymentInfo, 'creditCardUserInputInfo.billingAddress.id', '');
    /**
     * Add billing address to the profile if billing address form is enabled or transient shipping address exist in order
     */
    if (
        paymentInfo.showEditBillingAddressForm ||
        (paymentInfo.showNewCreditCardForm && !relationshipAddressId)
    ) {
        let billingAddress = get(paymentInfo, 'creditCardUserInputInfo.billingAddress', {});
        if (paymentInfo.showEditBillingAddressForm) {
            billingAddress = yield select(userInputAddressSelector);
        }
        const USCountries = ['APO', 'FPO', 'DPO'];
        if (USCountries.includes(billingAddress.country)) {
            billingAddress.city = billingAddress.country;
            billingAddress.country = 'AP';
        }

        const addressResult = yield call(addBillingAddressToProfile, billingAddress);

        if (!addressResult.isSuccess) {
            return addressResult;
        }
        addressId = get(addressResult, 'response.data.id', '');
    } else if (paymentInfo.showNewCreditCardForm) {
        addressId = relationshipAddressId;
    } else {
        addressId = get(paymentInfo, 'selectedCardInfo.paymentSource.address.id', '');
    }
    const cardInfo = get(paymentInfo, 'creditCardUserInputInfo.cardInfo', {});
    const addCardPayload = {
        type: cardInfo.type.toUpperCase(),
        cvv: cardInfo.cvv,
        expressCheckout: cardInfo.isExpressCheckout,
        address: {
            id: addressId,
        },
        errorHandler,
    };

    /* Pass expiry month and year if card type is JCP */
    if (cardInfo.type !== 'jcp') {
        addCardPayload.expiryMonth = cardInfo.expMonth;
        addCardPayload.expiryYear = cardInfo.expYear;
    }

    /* Pass card number if it's updated */
    const orderCardNumber = get(paymentInfo, 'selectedCardInfo.number', '');
    if (orderCardNumber !== cardInfo.number) {
        addCardPayload.cardNumber = cardInfo.number.replace(/[^(0-9)|*]/g, '');
    }

    if (paymentInfo.captchaToken) {
        addCardPayload.captcha = {
            token: paymentInfo.captchaToken,
        };
    }

    let result = null;
    const addPaymentToProfilePayload = {
        payload: addCardPayload,
    };
    let actionName = 'Checkout_add_credit_card';
    const contextSelector = yield select(context);
    // const { enableEnterpriseV3Captcha } = (contextSelector || {}).featureFlags || {};
    let headers = '';
    let captchaHeader = '';
    if (cardInfo.id) {
        actionName = isITRM ? 'Checkout_reenter_credit_card' : 'Checkout_update_credit_card';
        addPaymentToProfilePayload.payload.cardId = cardInfo.id;
        const deviceInfo = yield call(getAccertifyDeviceInfo, { actionName });
        if (deviceInfo) {
            addPaymentToProfilePayload.payload.deviceInfo = deviceInfo;
        }
        result = yield call(FactorySaga, updatePayment, addPaymentToProfilePayload);
        headers = get(result, 'response.headers');
        captchaHeader = headers && headers.get('x-svrc');
        // analyticsCode = isITRM ? 'cprc' : 'cpuc';
        yield call(
            handleCaptchaAnalytics,
            result,
            captchaHeader,
            actionName
            // analyticsCode,
            // enableEnterpriseV3Captcha,
        );
    } else {
        const { deviceType } = contextSelector;
        const deviceClientId = getClientId(deviceType);
        addPaymentToProfilePayload.payload.clientId = deviceClientId;
        const deviceInfo = yield call(getAccertifyDeviceInfo, { actionName });
        if (deviceInfo) {
            addPaymentToProfilePayload.payload.deviceInfo = deviceInfo;
        }
        result = yield call(FactorySaga, addPayment, addPaymentToProfilePayload);
        headers = get(result, 'response.headers');
        captchaHeader = headers && headers.get('x-svrc');
        yield call(
            handleCaptchaAnalytics,
            result,
            captchaHeader,
            actionName
            // analyticsCode,
            // enableEnterpriseV3Captcha
        );
    }

    /** regular failure, success - allowed to call addCCtoOrder
     * ADI failure - block user to addCCtoOrder
     */
    const adiStatus = result?.response?.headers?.get('x-adi-sts');
    const isAdiMonitoringMode = result?.response?.headers?.get('x-adi-monitor');
    const isAdiReject = !result.isSuccess && adiStatus === 'R' && !isAdiMonitoringMode;
    const isAddCCToProfile = actionName.includes('add');

    ['A', 'R'].includes(adiStatus)
        ? yield call(logExtendedAnalytics, {
              result,
              isTriggerFromLS: isAddCCToProfile && result.isSuccess,
              actionMethod: isAddCCToProfile ? 'ADD_CC_STP' : 'UPDATE_CC_STP',
          })
        : '';
    return isAdiReject ? { isADIError: true } : result;
}

/**
 * Add payment into the order from user profile
 * @param accountPaymentMethodId
 * @param captchaToken
 * @returns response of OrderApi.submitPayment API
 */
function* addAccountCreditCardInfoToOrder(accountPaymentMethodId) {
    const accountCCOrderParams = {
        payload: {
            relationships: {
                accountPaymentMethod: {
                    id: accountPaymentMethodId,
                },
            },
            errorHandler,
        },
    };
    // TODO add recaptchaToken
    const contextSelector = yield select(context);
    const { deviceType } = contextSelector;
    // const { enableEnterpriseV3Captcha } = (contextSelector || {}).featureFlags || {};
    const deviceClientId = getClientId(deviceType);
    accountCCOrderParams.payload.clientId = deviceClientId;
    const result = yield call(FactorySaga, submitPayment, accountCCOrderParams);
    const headers = get(result, 'response.headers');
    const captchaHeader = headers && headers.get('x-svrc');
    yield call(
        handleCaptchaAnalytics,
        result,
        captchaHeader,
        'Checkout_reenter_credit_card'
        // 'cprc',
        // enableEnterpriseV3Captcha
    );
    if (!result.isSuccess) {
        // TODO - challenge yet to Implement
        yield call(handleCreditCardADIChallenge, result, { actionMethod: 'SWITCH_CC' });
    }
    return result;
}

/**
 * Add contact method to order email
 * @param paymentInfo
 * @return return true if OrderApi.putEmailAddress API is success, else return false
 */
function* addContactMethodToOrder(paymentInfo) {
    const orderPaymentInfo = yield select(orderContactInfoSelector);
    const billingFormEmailId = get(paymentInfo, 'creditCardUserInputInfo.emailId', '');
    if (orderPaymentInfo.emailId === billingFormEmailId) {
        return true;
    }
    const emailPayload = {
        payload: {
            params: {
                type: 'EMAIL',
                purpose: 'TRANSACTIONAL',
                value: billingFormEmailId,
            },
            errorHandler,
        },
    };
    const result = yield call(FactorySaga, putEmailAddress, emailPayload);
    /**
     * Guest user optin call for email subscription
     */
    if (result.isSuccess) {
        if (!User.isUserLoggedIn()) {
            yield put({
                type: ANALYTICS_GUEST_EMAIL_OPTIN,
                payload: {
                    preferences: [
                        {
                            optinType: 'email',
                            optinFlag: 'yes',
                            notificationType: 'marketing',
                            source: 'payment',
                        },
                    ],
                },
            });
        }
        yield call(addOptinInfoToOrder, paymentInfo);
    }
    return result.isSuccess;
}

function getCaptchaToken(siteKeys) {
    const siteKeyV3 = getEnterpriseSiteKey(siteKeys);
    return window.grecaptcha.enterprise
        .execute(siteKeyV3, {
            action: 'CAM_update_credit_card',
        })
        .then((token) => token);
}
/**
 * Add payment info to the order and update to the user profile if user logged in
 */
function* handlePaymentSubmitRequestSaga(token) {
    const paymentInfo = yield select(paymentInfoSelector);
    const orderDetailsInfo = yield select(orderDetails);
    const { showEditBillingAddressForm } = paymentInfo;
    const contextInfo = yield select(context);
    const siteKeys = get(contextInfo, 'preferences.siteKeys', {});
    paymentInfo.captchaToken = token && token.value;
    if (paymentInfo.showNewCreditCardForm) {
        const errorInfo = yield call(checkFormErrors);
        if (!isEmpty(errorInfo)) {
            return;
        }
        yield put(showGlobalLoader(true));
        const isUserLoggedIn = User.isUserLoggedIn();
        if (isUserLoggedIn) {
            const saveCardToProfile = get(
                paymentInfo,
                'creditCardUserInputInfo.cardInfo.saveCardToProfile.selected',
                false
            );
            if (saveCardToProfile) {
                /*
                 * Save payment information into register user profile
                 */
                const addCreditCardInfoToProfileResult = yield call(
                    addCreditCardInfoToProfile,
                    paymentInfo,
                    false
                );
                if (addCreditCardInfoToProfileResult.isSuccess) {
                    const accountPaymentMethodId = get(
                        addCreditCardInfoToProfileResult,
                        'response.data.id'
                    );
                    /*
                     * Add saved card information from profile into order
                     */
                    const addAccountCreditCardInfoToOrderResult = yield call(
                        addAccountCreditCardInfoToOrder,
                        accountPaymentMethodId,
                        paymentInfo.captchaToken
                    );
                    if (addAccountCreditCardInfoToOrderResult.isSuccess) {
                        yield call(handlePromoFinance);
                    } else {
                        yield call(
                            addCreditCardToOrderErrorHandler,
                            addAccountCreditCardInfoToOrderResult
                        );
                    }
                } else {
                    /*
                     * Add register user payment information into order if not able to add into user profile
                     */

                    /*
                     * Get new captcha token from google since previous token invalidated by CAM
                     */
                    if (!addCreditCardInfoToProfileResult.isADIError) {
                        if (paymentInfo.captchaToken) {
                            const updatedToken = yield call(getCaptchaToken, siteKeys);
                            paymentInfo.captchaToken = updatedToken;
                            yield delay(100);
                            yield call(addCreditCardInfoToOrder, paymentInfo);
                        } else {
                            yield call(addCreditCardInfoToOrder, paymentInfo);
                        }
                    }
                }
            } else {
                /*
                 * Add register user payment information into order if user don't want to save into profile
                 */
                yield call(addCreditCardInfoToOrder, paymentInfo);
            }
        } else {
            /*
             * Add contact method to order if user is guest
             */
            const isContactMethodSuccess = yield call(addContactMethodToOrder, paymentInfo);
            if (isContactMethodSuccess) {
                /*
                 * Add guest user payment information into order
                 */
                yield call(addCreditCardInfoToOrder, paymentInfo);
            }
        }
    } else {
        const orderBillingInfo = yield select(orderBillingInfoSelector);
        const userPaymentList = yield select(userPaymentListSelector);
        const selectedPayment = find(userPaymentList, { selected: true }) || {};

        /**
         * If user paid with full amount with gift card,
         * Guest user - Should update email addressa, contact number, optin, billing address and redirect to review page
         * Register user - Should update billing address and redirect to review page
         */
        const isPartialGiftCardPayment = PaymentService.isPartialGiftcardPayment(orderDetailsInfo);
        const isUserLoggedIn = User.isUserLoggedIn();
        yield put(showGlobalLoader(true));
        if (!isPartialGiftCardPayment) {
            let isSubmitBillingAddressReady = true;
            /**
             * User Paid full amount Using GC for Guest User Only.
             */
            if (!isUserLoggedIn) {
                let errorInfo = {};
                if (showEditBillingAddressForm) {
                    errorInfo = yield call(checkFormErrors);
                }
                errorInfo.phone = validateCreditCardFormField(paymentInfo, 'phone', contextInfo);
                errorInfo.emailId = validateCreditCardFormField(
                    paymentInfo,
                    'emailId',
                    contextInfo
                );
                if (errorInfo.phone || errorInfo.emailId) {
                    /*
                     * Set phone number or email id error into the payment form
                     */
                    yield all([
                        put(
                            siteAnalyticsAction.triggerFormError(
                                PaymentService.getDAPaymentFormError(errorInfo)
                            )
                        ),
                        put(newPaymentAction.updateCreditCardFormError(errorInfo)),
                    ]);

                    isSubmitBillingAddressReady = false;
                } else {
                    const isContactMethodSuccess = yield call(addContactMethodToOrder, paymentInfo);
                    if (!isContactMethodSuccess) {
                        isSubmitBillingAddressReady = false;
                    }
                }
            }
            if (isSubmitBillingAddressReady) {
                // adds billing information to order
                const errorInfo = yield call(checkFormErrors);
                if (isEmpty(errorInfo)) {
                    yield call(addBillingAddressInfoToOrder, paymentInfo);
                }
            }
            /**
             * Submitted Payment Method as ITRM OR UnVerified Card
             * 1. Card Validation Process
             * 2. Update Card details into Profile
             * 3. Redirect to Review Page
             */
        } else if (selectedPayment.isITRM || selectedPayment.cvvReentryRequired) {
            const errorInfo = yield call(checkFormErrors);
            if (isEmpty(errorInfo)) {
                /*
                 * Update payment information into profile
                 */
                const updateCreditCardInfoToProfileResult = yield call(
                    addCreditCardInfoToProfile,
                    paymentInfo,
                    true
                );
                if (updateCreditCardInfoToProfileResult.isSuccess) {
                    /*
                     * Add updated payment information to order
                     */
                    const updatedCreditCardId = get(
                        updateCreditCardInfoToProfileResult,
                        'response.data.id',
                        selectedPayment.id
                    );
                    const addAccountCreditCardInfoToOrderResult = yield call(
                        addAccountCreditCardInfoToOrder,
                        updatedCreditCardId,
                        paymentInfo.captchaToken
                    );
                    if (addAccountCreditCardInfoToOrderResult.isSuccess) {
                        yield call(handlePromoFinance);
                    } else {
                        yield call(
                            addCreditCardToOrderErrorHandler,
                            addAccountCreditCardInfoToOrderResult
                        );
                    }
                }
            }
        } else if (
            !selectedPayment.transientPayment &&
            get(orderBillingInfo, 'relationships.accountPaymentMethod.id', '') !==
                selectedPayment.id
        ) {
            /*
             * Add saved card information from profile into order
             */
            const addAccountCreditCardInfoToOrderResult = yield call(
                addAccountCreditCardInfoToOrder,
                selectedPayment.id,
                paymentInfo.captchaToken
            );
            if (addAccountCreditCardInfoToOrderResult.isSuccess) {
                yield call(handlePromoFinance);
            } else {
                yield call(addCreditCardToOrderErrorHandler, addAccountCreditCardInfoToOrderResult);
            }
        } else {
            /**
             * Paypal Payment, No ITRM, No Unverified Card & selected card mapped into Order API.
             * Redirect to Review Page once tap on Review Button
             */
            yield call(handlePromoFinance);
        }
    }
    yield put(showGlobalLoader(false));
}

function* handleUpdatePaypalContactInfoRequestSaga() {
    const paymentInfo = yield select(paymentInfoSelector);
    const isUserLoggedIn = User.isUserLoggedIn();
    const contextInfo = yield select(context);
    if (!isUserLoggedIn) {
        let errorInfo = {};
        errorInfo = yield call(checkFormErrors);
        errorInfo.emailId = validateCreditCardFormField(paymentInfo, 'emailId', contextInfo);
        if (errorInfo.emailId) {
            /*
             * Set email id error into the paypal contact form
             */
            yield all([
                put(
                    siteAnalyticsAction.triggerFormError(
                        PaymentService.getDAPaymentFormError(errorInfo)
                    )
                ),
                put(newPaymentAction.updateCreditCardFormError(errorInfo)),
            ]);
        } else {
            const isContactMethodSuccess = yield call(addContactMethodToOrder, paymentInfo);
            if (isContactMethodSuccess) {
                yield put({ type: CLEAR_ORDER_ERROR, payload: 'reviewPayment' });
                yield put(showGlobalLoader(true));
                yield call(updateOldCartDetailsSaga, 'review', true);
                getBrowserHistory().push(URL_REVIEW_PAGE);
            }
        }
    }
}
function* updateUserPaymentList(userPaymentList, orderDetailsInfo, options) {
    const orderBillingInfo = yield select(orderBillingInfoSelector);
    yield put(
        newPaymentAction.updateProfilePaymentList(userPaymentList, orderDetailsInfo, options)
    );
    const isBnplOnOrder = yield select(selectBnplOnOrder);

    let isCreditCardForPaymentAvailable = !isEmpty(orderBillingInfo) && !isBnplOnOrder;

    const relationshipExistInOrder = get(orderBillingInfo, 'relationships.accountPaymentMethod.id');
    if (relationshipExistInOrder && userPaymentList.length === 0) {
        isCreditCardForPaymentAvailable = false;
    }
    const isPartialGiftCardPayment = PaymentService.isPartialGiftcardPayment(orderDetailsInfo);
    if (
        (userPaymentList.length === 0 && !isCreditCardForPaymentAvailable) ||
        !isPartialGiftCardPayment
    ) {
        /*
         * Initialize empty credit card form for register user if no payment from profile and order
         */
        const deliveryInfo = yield select(orderShippingToHomeInfoSelector);
        let addressList = [];
        let userDefaultAddress = [];
        if (isEmpty(deliveryInfo) || isEmpty(deliveryInfo.address)) {
            const userAddress = yield call(getCustomerAddress);
            if (userAddress.isSuccess) {
                addressList = get(userAddress, 'response.data.data', []);
                if (addressList.length > 0) {
                    userDefaultAddress = filter(addressList, { expressCheckout: true });
                    if (userDefaultAddress.length === 0) {
                        userDefaultAddress = filter(addressList, { isDefault: true });
                    }
                    if (userDefaultAddress.length > 0) {
                        userDefaultAddress[0].lineOne = userDefaultAddress[0].addressLineOne;
                        userDefaultAddress[0].lineTwo = userDefaultAddress[0].addressLineTwo;
                        userDefaultAddress[0].lineThree = userDefaultAddress[0].addressLineThree;
                    }
                }
            }
        }
        // eslint-disable-next-line no-param-reassign
        options.isUserLoggedInSSR = true;
        // eslint-disable-next-line no-param-reassign
        options.doNotInitiateCreditCardForm = !(
            userPaymentList.length === 0 && !isCreditCardForPaymentAvailable
        );
        yield put(
            newPaymentAction.initEmptyCreditCardForm(orderDetailsInfo, options, userDefaultAddress)
        );
    }
}

/**
 * Fetch payment list from user profile
 * @param orderBillingInfo
 * @param options
 * @return response of AccountApi.fetchPaymentMethods API
 */
function* getPaymentListFromProfile(orderDetailsInfo, options) {
    const action = {
        payload: { errorHandler },
    };
    if (__SERVER__) {
        action.headers = options.context.headers;
    }
    /**
     * To Avoid fetchPaymentMethods call for below process
     * apply coupon or add GC or remove GC
     */
    const initiatedFromAdjustment = options && options.initiatedFromAdjustment;
    let paymentFromProfile = [];
    // git cookies data for b2b voucher use
    const contextInfo = yield select(context);
    const enableB2BVoucher = get(contextInfo, 'featureFlags.enableB2BVoucher');
    const cookies = get(contextInfo, 'headers.cookies');
    const isAgent = cookies?.DP_USER_ROLE;
    if (!initiatedFromAdjustment) {
        const result = yield call(
            FactorySaga,
            enableB2BVoucher && isAgent ? fetchB2bPayment : fetchPaymentMethods,
            action
        );
        if (result.isSuccess) {
            paymentFromProfile = get(result, 'response.data.data', []);
        }
    } else {
        paymentFromProfile = yield select(userPaymentListSelector);
    }
    yield call(updateUserPaymentList, paymentFromProfile, orderDetailsInfo, options);
    return paymentFromProfile;
}

function* handleADIInitiateCheckoutException(orderDetailsInfo) {
    const exceptions = orderDetailsInfo?.data?.status?.exceptions;
    if (exceptions.length > 0) {
        const ADIexception = find(exceptions, (eachException) =>
            ADI_INITIATE_CHECKOUT_EXCEPTION_HANDLER.includes(eachException.errorCode)
        );
        /** render initCheckout ADI exception as errorMessage and handle Challenge */
        yield put({
            type: SET_SERVICE_ERROR,
            errorHandlerInfo: {
                ...ADIexception,
                errorComponent: 'PAYMENT_SECTION',
                context: 'PAYMENT',
            },
        });
        if (ADIexception?.errorCode === 'SRV_CREDIT_CARD_CVV_REENTRY_REQUIRED') {
            yield call(handleCreditCardADIChallenge, { fromIntiateCheckout: true });
        }
    }
}
/**
 * Initialize payment reducer
 */
export default function* handleInitPaymentRequestSaga(action) {
    let isUserLoggedIn = User.isUserLoggedIn();
    const orderDetailsInfo = yield select(orderDetails);
    const contextInfo = yield select(context);
    const enableAccertifyADI = get(contextInfo, 'featureFlags.enableAccertifyADI');
    const options = {
        context: contextInfo,
        initiatedFromAdjustment: (action && action.initiatedFromAdjustment) || false,
    };
    if (__SERVER__) {
        const cookies = get(contextInfo, 'headers.cookies');
        isUserLoggedIn = cookies.DP_USER_STATE === '1';
    }
    // Special Discount to use JCPenney Credit Card
    yield put(newPaymentAction.getSpecialDiscountInfo(orderDetailsInfo));
    // Gift Card
    yield put(newPaymentAction.getGiftCardList(orderDetailsInfo, options));
    if (!options.initiatedFromAdjustment) {
        yield put(newShippingAction.clearUserInputAddress(contextInfo));
    }

    const paymentInfo = yield select(paymentInfoSelector);
    const isBnplBlocked = yield select(selectBnplBlocked);
    const isBnplOnOrder = yield select(selectBnplOnOrder);
    const { isBnplSelected = false } = paymentInfo;
    if (!isBnplSelected && !isBnplBlocked && isBnplOnOrder) {
        /**
         * Select BNPL on load of the payment page when...
         *  Returning to edit payment after BNPL was added as the payment method on the order
         */
        // eslint-disable-next-line no-use-before-define
        yield call(handleChangePaymethodTypeSaga, { methodType: 'bnpl' });
    } else if (isBnplSelected && isBnplBlocked) {
        /**
         * Unselect BNPL when...
         *  Gift card payment is applied to the order
         *  Any item goes out of stock during BNPL application
         *  Order totals are TBD
         */
        // eslint-disable-next-line no-use-before-define
        yield call(handleChangePaymethodTypeSaga, {
            methodType: 'creditCard',
            isGCAppliedOnBnplSelected: action?.isGCAppliedOnBnplSelected,
        });
    }

    if (isUserLoggedIn) {
        /*
         * Initialize payment list from register user profile and order
         */
        options.initiatedFromAdjustment = false;
        const profilePaymentList = yield call(getPaymentListFromProfile, orderDetailsInfo, options);
        const userPaymentList = yield select(userPaymentListSelector);
        const selectedPayment = find(userPaymentList, { selected: true }) || {};
        if (
            enableAccertifyADI &&
            profilePaymentList.length > 0 &&
            !selectedPayment?.isITRM &&
            !selectedPayment?.cvvReentryRequired
        ) {
            yield call(handleADIInitiateCheckoutException, orderDetailsInfo);
        }
    } else {
        const orderBillingInfo = yield select(orderBillingInfoSelector);
        if (isEmpty(orderBillingInfo) || isBnplOnOrder) {
            /*
             * Initialize credit card form for guest user
             */
            yield put(newPaymentAction.initEmptyCreditCardForm(orderDetailsInfo, options, {}));
        } else {
            /*
             * Initialize update credit card form for guest user
             */
            yield put(newPaymentAction.initGuestUpdateCreditCardForm(orderDetailsInfo, options));
        }
    }
    yield put(showGlobalLoader(false));
}

/**
 * Delete payment from user profile
 * @param action
 * @return {IterableIterator<*>}
 */
function* handleDeleteUserPaymentRequestSaga(action) {
    const params = {
        payload: {
            id: action.paymentId,
        },
    };
    params.payload.errorHandler = errorHandler;
    yield put(showGlobalLoader(true));
    const contextSelector = yield select(context);
    const { deviceType } = contextSelector;
    const deviceClientId = getClientId(deviceType);
    params.payload.clientId = deviceClientId;
    const result = yield call(FactorySaga, deletePayment, params);
    if (result.isSuccess) {
        /*
         * Reset delete confirmation modal
         */
        yield put(newPaymentAction.setDeleteConfirmationInfo(false));
        /*
         * Initialize payment list from register user profile and order
         */
        const orderDetailsInfo = yield select(orderDetails);
        const contextInfo = yield select(context);
        const options = {
            context: contextInfo,
        };
        yield call(getPaymentListFromProfile, orderDetailsInfo, options);
    } else {
        yield put(newPaymentAction.setDeleteConfirmationInfo(false));
    }
    yield put(showGlobalLoader(false));
}

/**
 * Update payment information into profile and order
 * @param action
 */
function* handleUpdateUserPaymentRequestSaga(action) {
    const paymentInfo = yield select(paymentInfoSelector);
    const isTransientPayment = get(paymentInfo, 'selectedCardInfo.transientPayment', false);
    paymentInfo.selectedCardInfo.number = isTransientPayment
        ? get(paymentInfo, 'selectedCardInfo.orderPaymentInfo.number', '')
        : get(paymentInfo, 'selectedCardInfo.paymentSource.cardNumber', '');
    const isRegisteredUser = TokenProvider.get('DP_USER_STATE') === '1';
    const actionMethod = isRegisteredUser ? 'UPDATE_CC_REGISTERED' : 'UPDATE_CC_GUEST';
    yield put(showGlobalLoader(true));
    if (action?.value) {
        paymentInfo.captchaToken = action.value;
    }
    const errorInfo = yield call(checkFormErrors);
    if (isEmpty(errorInfo)) {
        // isTransientPayment card edit & Update Payment
        let result = null;
        const cardInfo = get(paymentInfo, 'creditCardUserInputInfo.cardInfo', {});
        if (isTransientPayment) {
            result = yield call(addCreditCardInfoToOrder, paymentInfo, isTransientPayment);
        } else {
            /*
             * Update payment information into profile
             */
            result = yield call(addCreditCardInfoToProfile, paymentInfo, false);
            if (result.isSuccess && cardInfo.id) {
                /*
                 * Add updated saved card information into order
                 *  handle ADI analytics here instead of handling addAccountCreditCardInfoToOrder
                 */
                result = yield call(
                    addAccountCreditCardInfoToOrder,
                    cardInfo.id,
                    paymentInfo.captchaToken
                );
            }
        }
        if (result.isSuccess) {
            /** trigger ADI Success event for transient payment */
            if (isTransientPayment) {
                yield call(logExtendedAnalytics, {
                    result,
                    actionMethod,
                });
            }
            yield call(updateOldCartDetailsSaga);
            /*
             * Initialize payment list from register user profile and order selectedPaymentId
             */
            const orderDetailsInfo = yield select(orderDetails);
            const contextInfo = yield select(context);
            const options = {
                context: contextInfo,
                selectedPaymentId: cardInfo.id,
            };
            yield call(getPaymentListFromProfile, orderDetailsInfo, options);
        } else {
            !result.isADIError
                ? yield call(addCreditCardToOrderErrorHandler, result, actionMethod)
                : '';
        }
    }
    yield put(showGlobalLoader(false));
}
export function* updateAppGCList(key, checked, value) {
    const paymentInfo = yield select(paymentInfoSelector);
    const appGiftCardList = get(paymentInfo, 'appGiftCardList', []);
    if (appGiftCardList.length > 0) {
        let appWalletGCList = [...appGiftCardList];
        appWalletGCList = map(appWalletGCList, (eachItem) => {
            if (eachItem[key] === value) {
                eachItem.selected = checked;
            }
            return eachItem;
        });

        yield put({ type: CONTINUE_PROCESSING_APP_GIFT_CARDS, payload: appWalletGCList });
    }
}
/**
 * remove giftcard from Order
 * @param action contain only removeGiftCardId
 */
function* handleRemoveGiftCardRequestSaga(action) {
    const contextSelector = yield select(context);
    const { deviceType } = contextSelector;
    const deviceClientId = getClientId(deviceType);
    const params = {
        payload: {
            id: action.removeGiftCardId,
            clientId: deviceClientId,
        },
    };
    const paymentInfo = yield select(paymentInfoSelector);
    const { isBnplSelected = false } = paymentInfo;
    yield put(showGlobalLoader(true));
    const result = yield call(FactorySaga, removeGiftCard, params);
    if (!isEmpty(result)) {
        if (result.response.status === 204) {
            // To Update orderDetails value without deleted Gift card
            yield call(updateOldCartDetailsSaga, 'payment', false, isBnplSelected);
            // To show Cerdit card form
            const userPaymentList = yield select(userPaymentListSelector);
            let initiatedFromAdjustment = true;
            if (isEmpty(userPaymentList)) {
                initiatedFromAdjustment = false;
            }
            yield call(handleInitPaymentRequestSaga, { initiatedFromAdjustment });
            /**
             * Instead of clearing all the SRVErr
             *  need to clear that is needed
             */
            const orderDetailsInfo = yield select(orderDetails);
            const isPaypalSRVErr = isMaxLengthPaypalServiceError(orderDetailsInfo);
            if (isEmpty(isPaypalSRVErr)) {
                yield put({ type: CLEAR_ORDER_ERROR, payload: 'reviewPayment' });
            }
        } else {
            // Handle error return its checked state
            yield call(updateAppGCList, 'id', true, action.removeGiftCardId);
        }
    } else {
        // Handle error return its checked state
        yield call(updateAppGCList, 'id', true, action.removeGiftCardId);
    }
    yield put(showGlobalLoader(false));
}

function* submitGC(giftCardNumber, pin, isGiftCardfromWallet) {
    const action = {};
    /* const errorHandlerGiftCard = {
        context: 'GIFTCARD',
        errorComponent: 'GIFTCARD_SECTION',
    }; */
    action.payload = {
        errorHandler,
    };
    action.payload.number = giftCardNumber;
    action.payload.pin = pin;
    const contextSelector = yield select(context);
    const { deviceType } = contextSelector;
    const deviceClientId = getClientId(deviceType);
    action.payload.clientId = deviceClientId;
    const enableAccertifyADI = get(contextSelector, 'featureFlags.enableAccertifyADI');
    const deviceInfo = yield call(getAccertifyDeviceInfo, { actionName: 'add_Giftcard' });
    if (deviceInfo) {
        action.payload.deviceInfo = deviceInfo;
    }
    const result = yield call(FactorySaga, applyGiftCard, action);
    const isNative = get(contextSelector, 'isNative', false);
    if (!isEmpty(result) && result.response.status !== null) {
        if (result.response.status === 201) {
            if (isGiftCardfromWallet) {
                // DA ==> Trigger analytics event on successful gift card apply from wallet.
                yield put(
                    CheckoutAnalyticsAction.clickEventAnalyticsAction(
                        ANALYTICS_ACTIONS_APP_WALLET_GIFT_CARD_APPLY
                    )
                );
            }
            enableAccertifyADI
                ? yield call(logExtendedAnalytics, {
                      actionMethod: 'ADD_GC',
                      result,
                  })
                : '';
            const paymentInfo = yield select(paymentInfoSelector);
            const { isBnplSelected = false } = paymentInfo;
            const isGCAppliedOnBnplSelected = isBnplSelected;
            // To Update orderDetails value with added Gift card
            yield call(updateOldCartDetailsSaga);
            // To show Cerdit card form
            yield call(handleInitPaymentRequestSaga, {
                initiatedFromAdjustment: true,
                isGCAppliedOnBnplSelected,
            });
        } else {
            /** Handle ADI Error Response */
            const errorInfo = Array.isArray(result?.response?.data)
                ? result?.response?.data[0]
                : result?.response?.data;
            if (errorInfo?.errorCode === 'SRV_BILLING_GC_PAYMENT_GATEWAY_NOT_VERIFIED')
                yield call(logExtendedAnalytics, {
                    actionMethod: 'ADD_GC',
                    result,
                });
            // Handle srverror return its checked state
            isNative
                ? yield call(updateAppGCList, 'giftCardNumber', false, action.payload.number)
                : '';
        }
    } else {
        // Handle srverror return its checked state
        isNative ? yield call(updateAppGCList, 'giftCardNumber', false, action.payload.number) : '';
    }
}
function* handleSubmitGiftCardNewPaymentSaga() {
    yield put(showGlobalLoader(true));
    const paymentInfo = yield select(paymentInfoSelector);
    if (paymentInfo.giftCardInfo) {
        const appContext = yield select(context);
        const enableV2GiftCardForm = get(appContext, 'featureFlags.enableV2GiftCardForm', false);
        const errorInfo = validateGiftCardForm(paymentInfo, enableV2GiftCardForm);
        if (!isEmpty(errorInfo)) {
            /*
             * Set form error into the giftCard form
             */
            yield all([
                put(
                    siteAnalyticsAction.triggerFormError(
                        PaymentService.getDAPaymentFormError(errorInfo)
                    )
                ),
                put(newPaymentAction.giftCardFormError(errorInfo)),
            ]);
        } else {
            const giftCardNumber = get(paymentInfo, 'giftCardInfo.giftCardForm.giftCardNumber', '');
            const pin = get(paymentInfo, 'giftCardInfo.giftCardForm.securityCode', '');
            yield call(submitGC, giftCardNumber, pin);
        }
    }
    yield put(showGlobalLoader(false));
}

function* handleAppWalletSubmitGiftCardNewPaymentSaga(action) {
    const {
        payload: { giftCardNumber = '', pin = '' },
    } = action;
    yield put(showGlobalLoader(true));
    yield call(submitGC, giftCardNumber, pin, true);
    yield put(showGlobalLoader(false));
}
/**
 * MCYODA-30833 - remove order bound deleted CC information from redux state once its removed from orders
 *  guest - remove from CCInputInfo
 *  loggedInuser remove from userPaymentList and if userPaymentList is 0 then initiate new CC form
 */
function* removeCreditcardFromState(deletedCreditCardId) {
    const isUserLoggedIn = User.isUserLoggedIn();
    const contextInfo = yield select(context);
    const paymentInfo = yield select(paymentInfoSelector);
    let userPaymentList = yield select(userPaymentListSelector);
    const orderDetailsInfo = yield select(orderDetails);
    const options = {
        context: contextInfo,
    };
    let creditCardUserInputInfo = get(paymentInfo, 'creditCardUserInputInfo', {});
    creditCardUserInputInfo.errorCardInfo = {};

    if (isUserLoggedIn) {
        userPaymentList = PaymentService.deleteSavedPaymentCC(userPaymentList, deletedCreditCardId);
    } else {
        const cardInfo = PaymentService.getCreditCardUIMapFromAPI({}, options.context);
        creditCardUserInputInfo = {
            ...creditCardUserInputInfo,
            fieldTouchedInfo: {},
            cardInfo,
        };
    }
    if (isUserLoggedIn && userPaymentList.length > 0) {
        const preferredCardIndex = getPreferredPaymentCard(userPaymentList);
        userPaymentList[preferredCardIndex].selected = true;
    }
    yield put({
        type: newPaymentActionTypes.UPDATE_DELETED_CC,
        creditCardUserInputInfo,
        userPaymentList,
    });
    if (isUserLoggedIn && userPaymentList.length === 0)
        yield put(newPaymentAction.initEmptyCreditCardForm(orderDetailsInfo, options, {}));
}

function* handleChangePaymethodTypeSaga(action) {
    const orderBillingInfo = yield select(orderBillingInfoSelector);
    const orderDetailsInfo = yield select(orderDetails);
    const creditCardId = get(orderBillingInfo, 'id', '');
    const orderAdjustments = get(orderDetailsInfo, 'data.adjustments');
    const assocAdjustment = find(orderAdjustments, { code: ADJUSTMENT_TYPE_ASSOC_DISCOUNT });
    const restrictedCoupon = find(orderAdjustments, { paymentType: ADJUSTMENT_TYPE_RESTRICTED });
    const contextSelector = yield select(context);
    const enableAddBnplPaymentCouponHeader = get(
        contextSelector,
        'featureFlags.enableAddBnplPaymentCouponHeader',
        true
    );
    // delete creditcard payment when bnpl is selected
    // due to change in associate discount price
    // due to payment restricted coupon applied
    // if payment card type is not visa
    if (
        action.methodType === 'bnpl' &&
        !isEmpty(creditCardId) &&
        (!isEmpty(assocAdjustment) || !isEmpty(restrictedCoupon))
    ) {
        const deletePaymentMethodPayload = {
            payload: {
                paymentId: creditCardId,
            },
        };
        yield put(showGlobalLoader(true));
        const deleteResponse = yield call(
            FactorySaga,
            deletePaymentMethod,
            deletePaymentMethodPayload
        );
        yield put(showGlobalLoader(false));
        if (deleteResponse.isSuccess) {
            const deletedCreditCardId = !orderBillingInfo?.relationships?.accountPaymentMethod?.id
                ? creditCardId
                : '';
            yield call(updateOldCartDetailsSaga, 'payment', false, true);
            // MCYODA-30833 - update redux state
            if (deletedCreditCardId) yield call(removeCreditcardFromState, deletedCreditCardId);
            yield put({
                type: newPaymentActionTypes.UPDATE_PAYMENT_METHOD_TYPE_SUCCESS,
                methodType: action.methodType,
            });
        }
    } else {
        /**
         *  MCYODA-30484 if payment based coupon is added,
         *  SYF - do GET draft call with header
         *  Non SYF payment method - do GET draft call without header
         */
        const isGCAppliedOnBnplSelected = action?.isGCAppliedOnBnplSelected;
        if (
            enableAddBnplPaymentCouponHeader &&
            !isEmpty(restrictedCoupon) &&
            !isGCAppliedOnBnplSelected
        ) {
            yield put(showGlobalLoader(true));
            yield call(updateOldCartDetailsSaga, 'payment', false, action.methodType === 'bnpl');
            yield put(showGlobalLoader(false));
        }
    }
    const paymentInfoSelector = (state) => state.newPayment;
    const paymentInfo = yield select(paymentInfoSelector);
    const selectedBillingInfo = paymentInfo.orderBillingInfo;
    const orderShippingList = get(orderDetailsInfo, 'data.delivery.groups', []);
    const orderShipping = find(orderShippingList, { type: 'HOME' }) || {};
    const billingAddress =
        get(orderDetailsInfo, 'data.billing.creditCards.cards[0].address') ||
        get(orderDetailsInfo, 'data.billing.unnamed.address') ||
        orderShipping.address ||
        {};
    yield put({
        type: newPaymentActionTypes.UPDATE_PAYMENT_METHOD_TYPE_SUCCESS,
        methodType: action.methodType,
        billingAddress,
    });
    if (action.methodType !== 'bnpl') {
        LocalStorage.removeData('bnplSelected');
    }
}

function* getPollGCBalance() {
    const contextSelector = yield select(context);
    const refreshInterval = get(contextSelector, 'preferences.iosGCBalance.RefreshInterval', 4000);
    const maxRetry = get(contextSelector, 'preferences.iosGCBalance.maxRetry', 10);
    let retryCount = 0;
    while (true) {
        try {
            const gcBalance = TokenProvider.get('DP_APP_GC_BALANCE', true);
            const shouldRetry = !gcBalance || !gcBalance > 0;
            retryCount += 1;
            if (shouldRetry && retryCount < maxRetry) {
                yield delay(refreshInterval);
            } else {
                retryCount = 0;
                const appGCBalance = { gc_amount: gcBalance };
                yield all([
                    put(newPaymentAction.stopPollingGetGCBalanceInfo()),
                    put({
                        type: newPaymentActionTypes.CONTINUE_PROCESSING_WEB_APP_GC_BALANCE,
                        payload: appGCBalance,
                    }),
                ]);
            }
        } catch (err) {
            console.log('err');
        }
    }
}
function* handlePollGCBalanceInfo(action) {
    // polling logic
    yield race([
        call(getPollGCBalance, action),
        takeMaybe(newPaymentActionTypes.STOP_POLLING_GET_GC_BALANCE_INFO),
    ]);
}

function* handleAppGCBalance(action) {
    try {
        const { payload = {} } = action;
        yield put({
            type: newPaymentActionTypes.GIFT_CARDS_BALANCE_FROM_APP,
            payload,
        });
    } catch (err) {
        const logMessage = `Failed to get device related GC from app: GCBalanceInfo
            ${JSON.stringify(err)} `;
        console.error(logMessage);
    }
}
function* handleGetAppGiftCards() {
    const contextSelector = yield select(context);
    const isNative = get(contextSelector, 'isNative', false);
    const paymentInfo = yield select(paymentInfoSelector);
    const appGiftCardList = get(paymentInfo, 'appGiftCardList');
    const appliedGiftCardList = get(paymentInfo, 'giftCardInfo.appliedGiftCardList');
    // get App's wallet GC if initial appGiftCardList state is undefined or
    // appGiftCardList state has one or more GC to update the value
    if (isNative) {
        // for IOS call eachtime and send appliedGC because of applepay workaround
        if (window.webkit) {
            yield put(showGlobalLoader(true));
            const orderDetailsInfo = yield select(orderDetails);
            const totalOrder = PaymentService.getOrderTotal(orderDetailsInfo);
            const data = {
                appliedGiftCardList,
                totalOrder,
            };
            yield put(getNativeGiftCards(data));
            yield put(showGlobalLoader(false));
        }
        // Android flow
        else if (!appGiftCardList) {
            yield put(showGlobalLoader(true));
            yield put(getNativeGiftCards());
            yield put(showGlobalLoader(false));
        }
        // on subsequent add GC link get input from state and
        // format as like app and send
        // Android - applied GC list flow
        else if (appGiftCardList.length > 0) {
            const initialappGCFormat = appGiftCardList.map(({ selected, id, ...gclist }) => gclist);
            yield put({ type: CONTINUE_PROCESSING_APP_GIFT_CARDS, payload: initialappGCFormat });
        }
    }
}

function* handleAppGCLists(action) {
    try {
        const { payload = [] } = action;
        const paymentInfo = yield select(paymentInfoSelector);
        const appliedGiftCardList = get(paymentInfo, 'giftCardInfo.appliedGiftCardList', []);
        const appliedAppGCList =
            payload.length > 0 ? getAppliedAppGCList(payload, appliedGiftCardList) : payload;
        yield put({ type: GIFT_CARDS_FROM_APP, payload: appliedAppGCList });
    } catch (err) {
        const logMessage = `Failed to get device related GC from app: GCInfo
        ${JSON.stringify(err)} `;
        console.error(logMessage);
    }
}
const watchInitNewPaymentInitRequest = function* watchInitNewPaymentInitRequest() {
    yield takeLatest(newPaymentActionTypes.INIT_NEW_PAYMENT, handleInitPaymentRequestSaga);
};
watchInitNewPaymentInitRequest.sagaName = 'watchInitNewPaymentInitRequest';

const watchSubmitNewPaymentRequest = function* watchSubmitNewPaymentRequest() {
    yield takeLatest(newPaymentActionTypes.ADD_CREDIT_CARD, handlePaymentSubmitRequestSaga);
};
watchSubmitNewPaymentRequest.sagaName = 'watchSubmitNewPaymentRequest';

const watchAddBnplToOrder = function* watchAddBnplToOrder() {
    yield takeLatest(newPaymentActionTypes.ADD_BNPL_TO_ORDER, addBnplToOrder);
};
watchAddBnplToOrder.sagaName = 'watchAddBnplToOrder';

const watchDeleteUserPaymentNewPaymentRequest = function* watchDeleteUserPaymentNewPaymentRequest() {
    yield takeLatest(newPaymentActionTypes.DELETE_USER_PAYMENT, handleDeleteUserPaymentRequestSaga);
};
watchDeleteUserPaymentNewPaymentRequest.sagaName = 'watchDeleteUserPaymentNewPaymentRequest';

const watchUpdateUserPaymentNewPaymentRequest = function* watchUpdateUserPaymentNewPaymentRequest() {
    yield takeLatest(newPaymentActionTypes.UPDATE_USER_PAYMENT, handleUpdateUserPaymentRequestSaga);
};
watchUpdateUserPaymentNewPaymentRequest.sagaName = 'watchUpdateUserPaymentNewPaymentRequest';

const watchRemoveGiftCardNewPaymentRequest = function* watchRemoveGiftCardNewPaymentRequest() {
    yield takeLatest(
        newPaymentActionTypes.REMOVE_GIFTCARD_REQUEST,
        handleRemoveGiftCardRequestSaga
    );
};
watchRemoveGiftCardNewPaymentRequest.sagaName = 'watchRemoveGiftCardNewPaymentRequest';

const watchSubmitGiftCardNewPaymentRequest = function* watchSubmitGiftCardNewPaymentRequest() {
    yield takeLatest(
        newPaymentActionTypes.GIFT_CARD_FORM_SUBMIT,
        handleSubmitGiftCardNewPaymentSaga
    );
};
watchSubmitGiftCardNewPaymentRequest.sagaName = 'watchSubmitGiftCardNewPaymentRequest';

const watchPollGCBalanceInfo = function* watchPollGCBalanceInfo() {
    yield takeLatest(newPaymentActionTypes.POLL_GC_BALANCE_INFO, handlePollGCBalanceInfo);
};
watchPollGCBalanceInfo.sagaName = 'watchPollGCBalanceInfo';

const watchAppGCBalance = function* watchAppGCBalance() {
    yield takeLatest(
        newPaymentActionTypes.CONTINUE_PROCESSING_WEB_APP_GC_BALANCE,
        handleAppGCBalance
    );
};
watchAppGCBalance.sagaName = 'watchAppGCBalance';

const watchAppWalletSubmitGiftCardRequest = function* watchAppWalletSubmitGiftCardRequest() {
    yield takeLatest(
        newPaymentActionTypes.APP_WALLET_GIFT_CARD_FORM_SUBMIT,
        handleAppWalletSubmitGiftCardNewPaymentSaga
    );
};

watchAppWalletSubmitGiftCardRequest.sagaName = 'watchAppWalletSubmitGiftCardRequest';

const watchUpdatePaypalContactInfoRequest = function* watchUpdatePaypalContactInfoRequest() {
    yield takeLatest(
        newPaymentActionTypes.UPDATE_PAYPAL_CONTACT_INFO,
        handleUpdatePaypalContactInfoRequestSaga
    );
};
watchUpdatePaypalContactInfoRequest.sagaName = 'watchUpdatePaypalContactInfoRequest';

const watchAppGiftcards = function* watchAppGiftcards() {
    yield takeLatest(newPaymentActionTypes.GET_APP_GIFT_CARDS, handleGetAppGiftCards);
};
watchAppGiftcards.sagaName = 'watchAppGiftcards';

const watchAppGCList = function* watchAppGCList() {
    yield takeLatest(CONTINUE_PROCESSING_APP_GIFT_CARDS, handleAppGCLists);
};
watchAppGCList.sagaName = 'watchAppGCList';

const watchHandleChangePaymentMethodType = function* watchHandleChangePaymentMethodType() {
    yield takeLatest(
        newPaymentActionTypes.UPDATE_PAYMENT_METHOD_TYPE,
        handleChangePaymethodTypeSaga
    );
};
watchHandleChangePaymentMethodType.sagaName = 'watchHandleChangePaymentMethodType';

export {
    watchInitNewPaymentInitRequest,
    watchSubmitNewPaymentRequest,
    watchDeleteUserPaymentNewPaymentRequest,
    watchUpdateUserPaymentNewPaymentRequest,
    watchRemoveGiftCardNewPaymentRequest,
    watchSubmitGiftCardNewPaymentRequest,
    watchAppWalletSubmitGiftCardRequest,
    watchUpdatePaypalContactInfoRequest,
    watchPollGCBalanceInfo,
    watchAppGCBalance,
    watchAppGiftcards,
    watchAppGCList,
    watchHandleChangePaymentMethodType,
    watchAddBnplToOrder,
};
